import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { FlexAlignStyleBuilder } from '@angular/flex-layout';
import { AuthenticationService } from '../services/authentication.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ProgressSpinnerDialogComponent } from '../progress-spinner-dialog/progress-spinner-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
loginForm: FormGroup;
submitted = false;

  constructor(private formBuilder: FormBuilder, 
              private authService: AuthenticationService,
              private router: Router) { }

  ngOnInit() {
    localStorage.clear();
    this.loginForm = this.formBuilder.group({
      email: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required)
    });
  }

  onSubmit() {

    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.authService.authenticateUser(this.loginForm.value);
  }

  forgetPassword(){
    this.authService.forgetPassword(this.loginForm.value);
  }
  
  register(){
    this.router.navigate([`/register`]);
  }

}
